export default {
  TweetListPage_setScPos (state, {top}) {
    const listType = state.TweetListPage.listType
    state.TweetListPage.scrollTop[listType] = top || 0
  },
  TweetListPage_changeType (state, {type}) {
    const validTypes = ['myimgs', 'favs', 'stocks']
    if (!validTypes.includes(type)) {
      throw new Error('invalid type', type)
    }
    state.TweetListPage.listType = type
  },
  Flash_changeMsg (state, {msg}) {
    state.flash.msg = msg || null
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js